import { M } from '../palette';
import { blocks, bricks, planks, solid } from './builder';
import { tracedMap } from './traced';
import { DUST_LAYOUT } from './traced/dust2';

/**
 * Sunbaked Quarter: the floor plan of a famous two-site desert map (three routes: a long lane, a middle with a catwalk and a pair
 * of tunnels), rebuilt in our voxel style. The plan is traced from an overview image (see tools/trace-map.py and
 * docs/maps/traced-maps.md); the materials, wall heights, windows and props are ours.
 */
export const dustWorks = tracedMap({
  id: 'sunbaked_quarter',
  name: 'Sunbaked Quarter',
  description: 'A walled desert quarter with a long lane, a middle with tunnels, and two sites to fight over.',
  layout: DUST_LAYOUT,
  seed: 4101,
  modes: ['tdm', 'ffa', 'dom', 'ctf', 'sandbox', 'practice'],
  style: {
    floor: [M('sand_1'), M('sand_3'), M('sand_2'), M('sandstone_3')],
    floorEdge: M('dirt_3'),
    walls: [
      blocks([M('sandstone_1'), M('sandstone_2')], 3, 61),
      blocks([M('sandstone_3'), M('sandstone_1')], 3, 62),
      bricks([M('brick_yellow'), M('sandstone_2')], 63),
      solid([M('plaster_2'), M('plaster_3')], 64),
    ],
    perimeter: blocks([M('sandstone_2'), M('sandstone_1')], 5, 65),
    trim: M('sandstone_3'),
    window: M('tile_black'),
    crate: planks([M('planks_2'), M('planks_3')], 66),
    heights: [44, 52, 60, 68],
    perimeterHeight: 90,
  },
  theme: {
    skyTop: 0x5f98dc,
    skyHorizon: 0xf2dcb4,
    fog: 0xeed8b2,
    fogNear: 50,
    fogFar: 170,
    sun: [0.55, 0.7, 0.35],
    sunColor: 0xffe2b0,
    sunIntensity: 1.05,
    ambient: 0xd0d8f0,
    ambientIntensity: 0.55,
    outside: 0xcdb27a,
    music: 'desert',
  },
});
